module.exports = __webpack_public_path__ + "img/shareGoodGift.76f9eabd.png";